import React, { useState, useRef, useEffect } from 'react';
import { Settings, LogOut, ChevronDown, User } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const ProfileHeader = ({ onOpenProfileModal, profile }) => {
  const { user, logout } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const profileData = profile || user?.profile;

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/');
    setIsDropdownOpen(false);
  };

  const handleEditProfile = () => {
    onOpenProfileModal();
    setIsDropdownOpen(false);
  };

  const getInitials = () => {
    const name = profileData?.name || user?.profile?.name || user?.email || '';
    return name.split(' ').map(word => word.charAt(0)).join('').toUpperCase().slice(0, 2) || 'U';
  };

  const getDisplayName = () => {
    return profileData?.name || user?.profile?.name || user?.email?.split('@')[0] || 'User';
  };

  const getProfileImage = () => {
    return profileData?.profile_image_url || user?.profile?.profile_image_url || null;
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
      >
        {/* Avatar */}
        <div className="w-8 h-8 rounded-full flex items-center justify-center overflow-hidden border-2 border-gray-200">
          {getProfileImage() ? (
            <img
              src={getProfileImage()}
              alt={getDisplayName()}
              className="w-full h-full object-cover"
              onError={(e) => {
                // Fallback to initials if image fails to load
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
          ) : null}
          <div 
            className={`w-full h-full bg-gradient-to-r from-[#FC7A69] to-[#221E45] flex items-center justify-center text-white font-semibold text-sm ${getProfileImage() ? 'hidden' : 'flex'}`}
          >
            {getInitials()}
          </div>
        </div>

        {/* Name and Email */}
        <div className="hidden md:block text-left">
          <div className="text-sm font-medium text-gray-900">{getDisplayName()}</div>
          <div className="text-xs text-gray-500">{profileData?.email || user?.email}</div>
        </div>

        {/* Dropdown Arrow */}
        <ChevronDown
          className={`w-4 h-4 text-gray-500 transition-transform duration-200 ${
            isDropdownOpen ? 'rotate-180' : ''
          }`}
        />
      </button>

      {/* Dropdown Menu */}
      {isDropdownOpen && (
        <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
          {/* User Info Section */}
          <div className="px-4 py-3 border-b border-gray-100">
            <div className="flex items-center space-x-3">
              {/* <div className="w-10 h-10 rounded-full flex items-center justify-center overflow-hidden border-2 border-gray-200">
                {getProfileImage() ? (
                  <img
                    src={getProfileImage()}
                    alt={getDisplayName()}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      // Fallback to initials if image fails to load
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                ) : null}
                <div 
                  className={`w-full h-full bg-gradient-to-r from-[#FC7A69] to-[#221E45] flex items-center justify-center text-white font-semibold ${getProfileImage() ? 'hidden' : 'flex'}`}
                >
                  {getInitials()}
                </div>
              </div> */}
              <div>
                <div className="font-medium text-gray-900">{getDisplayName()}</div>
                {/* <div className="text-sm text-gray-500">{profileData?.email || user?.email}</div> */}
              </div>
            </div>
          </div>

          {/* Menu Items */}
          <div className="py-1">
            <button
              onClick={handleEditProfile}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <Settings className="w-4 h-4 mr-3" />
              Edit Profile
            </button>

            <button
              onClick={handleLogout}
              className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
            >
              <LogOut className="w-4 h-4 mr-3" />
              Logout
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileHeader;